import _slicedToArray from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useControlledValue } from "../helpers/useControlledValue.js";
import { addToRange, rangeContainsModifiers } from "../utils/index.js";
import { rangeIncludesDate } from "../utils/rangeIncludesDate.js";
export function useRange(props, dateLib) {
  var disabled = props.disabled,
    excludeDisabled = props.excludeDisabled,
    initiallySelected = props.selected,
    required = props.required,
    onSelect = props.onSelect;
  var _useControlledValue = useControlledValue(initiallySelected, onSelect ? initiallySelected : undefined),
    _useControlledValue2 = _slicedToArray(_useControlledValue, 2),
    internallySelected = _useControlledValue2[0],
    setSelected = _useControlledValue2[1];
  var selected = !onSelect ? internallySelected : initiallySelected;
  var isSelected = function isSelected(date) {
    return selected && rangeIncludesDate(selected, date, false, dateLib);
  };
  var select = function select(triggerDate, modifiers, e) {
    var min = props.min,
      max = props.max;
    var newRange = triggerDate ? addToRange(triggerDate, selected, min, max, required, dateLib) : undefined;
    if (excludeDisabled && disabled && newRange !== null && newRange !== void 0 && newRange.from && newRange.to) {
      if (rangeContainsModifiers({
        from: newRange.from,
        to: newRange.to
      }, disabled, dateLib)) {
        // if a disabled days is found, the range is reset
        newRange.from = triggerDate;
        newRange.to = undefined;
      }
    }
    if (!onSelect) {
      setSelected(newRange);
    }
    onSelect === null || onSelect === void 0 || onSelect(newRange, triggerDate, modifiers, e);
    return newRange;
  };
  return {
    selected: selected,
    select: select,
    isSelected: isSelected
  };
}